module.exports = __webpack_public_path__ + "static/media/ico_deman.940dac72.svg";